import NotificationHeader from "../components/NotificationHeader/NotificationHeader";
import React, { useState } from "react";
import WordsList from "../components/WordsList/WordsList";

const Spam = () => {
  const [isAddWord, setIsAddWord] = useState(false);

  return (
    <>
      <NotificationHeader name="Spam Management" />
      <div className="dashboardPage">
        <div className="container">
          <div className="pageStyle">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-12"></div>
              <div className="col-lg-6 col-md-6 col-12">
                <div className="text-end">
                  {!isAddWord && (
                    <button
                      className="primaryBtn"
                      onClick={() => {
                        setIsAddWord(true);
                      }}
                      type="button"
                    >
                      Add Word
                    </button>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <WordsList isAddWord={isAddWord} setIsAddWord={setIsAddWord} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Spam;
